// src/components/PushRegistrar.js
import { useEffect } from "react";
import { registerPushForUser, listenForegroundMessages } from "../utils/pushToken";

// Renders nothing. Registers this device's push token when the site opens
// (login itself is handled in Login.jsx) and shows notifications while the tab is open.
export default function PushRegistrar() {
  useEffect(() => {
    registerPushForUser();
    const stopListening = listenForegroundMessages();
    return () => {
      if (typeof stopListening === "function") stopListening();
    };
  }, []);
  return null;
}